import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user-info"));

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-light shadow">
        <div className="container">
          <NavLink className="navbar-brand fw-bolder fs-4 me-auto" to="/">
            <img src="/assets/logo.png" className="image" alt="Company Logo" />
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              {/* Home */}
              <li className="nav-item">
                <NavLink className="nav-link" to="/">Home</NavLink>
              </li>

              {/* Our Company Dropdown */}
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle btn btn-link"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Our Company
                </button>
                <ul className="dropdown-menu">
                  <li><NavLink className="dropdown-item" to="/about">About</NavLink></li>
                  <li><NavLink className="dropdown-item" to="/OurTeam">Our Team</NavLink></li>
                  <li><NavLink className="dropdown-item" to="/Gallery">Gallery</NavLink></li>
                  <li><NavLink className="dropdown-item" to="/SocialMediaGallery">Social Media</NavLink></li>
                </ul>
              </li>

              {/* Our Services Dropdown */}
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle btn btn-link"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Our Services
                </button>
                <ul className="dropdown-menu">
                  <li><NavLink className="dropdown-item" to="/services">All Services</NavLink></li>
                  <li><NavLink className="dropdown-item" to="/Powerbi">Power BI Reports</NavLink></li>
                  <li><NavLink className="dropdown-item" to="/Advexl">Advance Excel</NavLink></li>                  
                  <li><NavLink className="dropdown-item" to="/Corptrg">Corporate Trainings</NavLink></li>
                  <li><NavLink className="dropdown-item" to="/Plans">CyberSecurity</NavLink></li>
                </ul>
              </li>

              {/* Career */}
              <li className="nav-item">
                <NavLink className="nav-link" to="/Career">Career</NavLink>
              </li>

              {/* Contact */}
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact">Contact</NavLink>
              </li>

              {/* NexGen-i External Links */}
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle btn btn-link"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  NexGen-i
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://jobs.bytlas.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Bytlas Jobs
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://eshop.bytlas.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Bytlas-eShop
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://learn-Smart.bytlas.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Bytlas-learn-Smart
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://flix.bytlas.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    > Bytlas-Flix
                    </a>
                  </li>
                  
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://cybersecurity.bytlas.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    > Cybersecurity
                    </a>
                  </li>
                  
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://bytlas.online/"
                      target="_blank"
                      rel="noopener noreferrer"
                    > Bytla-online
                    </a>
                  </li>

                  <li>
                    <a
                      className="dropdown-item"
                      href="https://bytlasinternational.online/"
                      target="_blank"
                      rel="noopener noreferrer"
                    > Bytlasinternational-Online
                    </a>
                  </li>
                </ul>
              </li>
            </ul>

            <div className="py-1">
              <div className="container">
                <div className="d-flex flex-column align-items-start small">

                  <a
                    href="mailto:info@bytlasintelligence.com"
                    className="text-decoration-none text-dark"
                  >
                    <i className="fa fa-envelope me-2 theme-blue"></i>
                    info@bytlas.com
                  </a>

                  <a
                    href="tel:+918169886795"
                    className="text-decoration-none text-dark"
                  >
                    <i className="fa fa-phone me-2 theme-blue"></i>
                    +91 81698 86795
                  </a>

                </div>
              </div>
            </div>
            {/* Right Side Box - Auth Buttons */}
            <div className="rightbox d-flex align-items-center">
              {user ? (
                <>
                  <span className="me-3 fw-bold text-primary">Hi, {user.name}</span>
                  <button onClick={handleLogout} className="btn btn-danger px-4 rounded-pill">
                    <i className="fa fa-sign-out me-2"></i>Logout
                  </button>
                </>
              ) : (
                <>
                  <NavLink to="/login" className="btn btn-primary px-4 rounded-pill me-2">
                    <i className="fa fa-sign-in me-2"></i>Login
                  </NavLink>
                  <NavLink to="/register" className="btn btn-outline-primary px-4 rounded-pill">
                    <i className="fa fa-user-plus me-2"></i>Register
                  </NavLink>
                </>
              )}
            </div>
          </div>
        </div>


      </nav>


    </div>
  );
}
